import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-lightShow" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "absolute z-10 bg-gradient-to-b bottom-0 from-transparent to-black w-full h-1/2 opacity-70" }, null, -1)
const _hoisted_5 = { class: "absolute text-xl text-white bottom-5 left-5 z-20" }
const _hoisted_6 = { class: "p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SVoucherCard = _resolveComponent("SVoucherCard")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "aspect-video object-cover",
        src: _ctx.voucherCategory?.imageUrl,
        alt: ""
      }, null, 8, _hoisted_3),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", null, _toDisplayString(_ctx.voucherCategory?.name), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_van_list, {
        loading: _ctx.isLoading,
        "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
        finished: _ctx.vouchers.isFinal,
        "finished-text": "",
        "loading-text": "loading",
        class: "space-y-4",
        onLoad: _ctx.loadMoreVouchers
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vouchers.data, (voucher) => {
            return (_openBlock(), _createElementBlock("div", {
              key: voucher.voucherId
            }, [
              _createVNode(_component_SVoucherCard, { voucher: voucher }, null, 8, ["voucher"])
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["loading", "finished", "onLoad"])
    ])
  ]))
}